// Matriz de permisos para los menús principales del dashboard
export const permisosMenusDashboard = {
  dashboard: [
    'terapeuta', 'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  contacto: [
    'terapeuta', 'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  categorias: [
    'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  servicios: [
    'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  turnos: [
    'terapeuta', 'coord_programa', 'admin', 'coord_ceseco', 'secretaria'
  ],
  citas: [
    'secretaria', 'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  disponibilidad: [
    'terapeuta', 'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  banners: [
    'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  usuarios: [
    'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  reportes: [
    'direccion', 'admin', 'coord_ceseco'
  ],
  talleres: [
    'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  'citas-talleres': [
    'terapeuta', 'secretaria', 'coord_programa', 'coord_ceseco', 'direccion', 'admin'
  ],
  'logs-whatsapp': [
    'admin'
  ]
};

export function puedeVerMenu(rol, menu) {
  return permisosMenusDashboard[menu]?.includes(rol);
} 

// Excel y PDF llevan datos personales de pacientes y usuarios: solo dirección y administración los descargan
export function puedeExportar(rol) {
  return ['direccion', 'admin'].includes(rol);
}
